require("./src/treeGrid.css");
module.exports = require("./src/tree-grid-directive.js");


//////////////////
// WEBPACK FOOTER
// angular-bootstrap-grid-tree (bower component)
// module id = 1431
// module chunks = 0